module.exports = __webpack_public_path__ + "static/icon_tools_contact_sprite.0b202c43.png";